export function valueToSelectOption(value, selectOptions) {
  return (selectOptions || []).filter((option) => option?.value === value)[0];
}
